module.exports = __webpack_public_path__ + "static/media/favicon.548ddd8c.ico";